module.exports = __webpack_public_path__ + "img/avatar.7dee914a.jpeg";